import React from "react";
import { useFormattedMessage, useSideModalScrollToTop } from "hooks";
import InfoCard from "./InfoCard";
import InfoIconBlack from "assets/images/svg/info-icon-black.svg";
import NewLoader from "components/NewLoader";

const messages = {
    confirmIdentityWithMangopay: "confirm_identity_with_mangopay",
    reasonForVerification: "reason_for_verification",
    complyWithRegulatoryRequirements: "comply_with_regulatory_requirements",
    redirectedToMangopay: "redirected_to_mangopay",
    verifySecurelyWithMangopay: "verify_securely_with_mangopay",
    verifyNow: "verify_now",
};

const MangopayScaVerification = ({
    overridePaddingClassName,
    backSlideEffect = "",
    isLoading = false,
    requestError,
    theme = "light",
    onButtonClick = () => {},
}) => {
    useSideModalScrollToTop();

    const { formatMessage } = useFormattedMessage();

    return (
        <div
            className={`${overridePaddingClassName || "px-6 py-8"} ${backSlideEffect} ${theme === "dark" ? "mangopay-sca-theme-dark" : "mangopay-sca-theme-light"}`}
        >
            <div className="mb-6">
                <img
                    className="mangopay-logo"
                    src="/images/mangopay-logo.png"
                    alt="Mangopay Logo"
                    style={{ maxWidth: "140px" }}
                />
            </div>
            <InfoCard bgColor="#F9EEED" icon={<InfoIconBlack />} content={formatMessage(messages.confirmIdentityWithMangopay)} />
            <InfoCard
                bgColor="#F6F6F8"
                title={formatMessage(messages.reasonForVerification)}
                content={formatMessage(messages.complyWithRegulatoryRequirements)}
            />
            <p className="text-14 light-grey-color mb-6">{formatMessage(messages.redirectedToMangopay)}</p>
            <button className="mw-100" onClick={onButtonClick} disabled={isLoading}>
                {isLoading && <NewLoader />}
                {formatMessage(messages.verifyNow)}
            </button>
            {requestError && <span className="error pl-0">{requestError}</span>}
        </div>
    );
};

export default MangopayScaVerification;
